import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasskeyInfoCmsKey = 'Created' | 'LastUsed' | 'Location';

export const PasskeyInfoCmsWithDefault: CmsObjectWithDefault<PasskeyInfoCmsKey> = {
    Created: {
        cmsId: 553055,
        defaultTranslation: 'Created:',
    },
    LastUsed: {
        cmsId: 553056,
        defaultTranslation: 'Last used:',
    },
    Location: {
        cmsId: 553057,
        defaultTranslation: 'Location:',
    },
};
